import { banrisulLogo, bbLogo, bradescoLogo, c6bankLogo, caixaLogo, interLogo, itauLogo, nubankLogo, pluggyLogo, santanderLogo, sicobLogo, sicrediLogo, unicredLogo, } from '@ibk/shared-assets';
import { ConsentPartner, ConsentStatusCode, ConsentSyncStatus, OpenFinanceBankTypes } from '../../../../services/types';
export const bankData = {
    [OpenFinanceBankTypes.BANCO_DO_BRASIL]: {
        label: 'Banco do Brasil',
        logo: bbLogo,
    },
    [OpenFinanceBankTypes.BRADESCO]: {
        label: 'Bradesco',
        logo: bradescoLogo,
    },
    [OpenFinanceBankTypes.BANRISUL]: {
        label: 'Banrisul',
        logo: banrisulLogo,
    },
    [OpenFinanceBankTypes.CAIXA]: { label: 'Caixa', logo: caixaLogo },
    [OpenFinanceBankTypes.ITAU]: { label: 'Itaú', logo: itauLogo },
    [OpenFinanceBankTypes.NUBANK]: {
        label: 'Nubank',
        logo: nubankLogo,
    },
    [OpenFinanceBankTypes.SANTANDER]: {
        label: 'Santander',
        logo: santanderLogo,
    },
    [OpenFinanceBankTypes.SICOOB]: {
        label: 'Sicoob',
        logo: sicobLogo,
    },
    [OpenFinanceBankTypes.SICREDI]: {
        label: 'Sicredi',
        logo: sicrediLogo,
    },
    [OpenFinanceBankTypes.UNICRED]: {
        label: 'Unicred',
        logo: unicredLogo,
    },
    [OpenFinanceBankTypes.PLUGGY]: {
        label: 'Pluggy',
        logo: pluggyLogo,
    },
    [OpenFinanceBankTypes.INTER]: {
        label: 'Inter',
        logo: interLogo,
    },
    [OpenFinanceBankTypes.C6_BANK]: {
        label: 'C6 Bank',
        logo: c6bankLogo,
    },
};
export const statusDisplay = {
    [`${ConsentStatusCode.CONNECTED}:${ConsentSyncStatus.SYNCED}`]: {
        labelKey: 'contabilidade-digital.bank-status-connected',
        variant: 'success',
    },
    [`${ConsentStatusCode.CONNECTED}:${ConsentSyncStatus.WITH_ISSUES}`]: {
        labelKey: 'contabilidade-digital.bank-status-connected_unstable',
        tooltipKey: 'contabilidade-digital.bank-status-connected_unstable-tooltip',
        variant: 'warning',
    },
    [ConsentStatusCode.CONNECTING]: {
        labelKey: 'contabilidade-digital.bank-status-connecting',
        tooltipKey: 'contabilidade-digital.bank-status-connecting-tooltip',
        variant: 'info',
    },
    [ConsentStatusCode.ACCOUNT_INVALID_CREDENTIALS]: {
        labelKey: 'contabilidade-digital.bank-status-account_invalid_credentials',
        tooltipKey: 'contabilidade-digital.bank-status-account_invalid_credentials-tooltip',
        variant: 'error',
    },
    [ConsentStatusCode.ACCOUNT_LOCKED]: {
        labelKey: 'contabilidade-digital.bank-status-account_locked',
        tooltipKey: 'contabilidade-digital.bank-status-account_locked-tooltip',
        variant: 'error',
    },
    [ConsentStatusCode.USER_AUTHORIZATION_NOT_GRANTED]: {
        labelKey: 'contabilidade-digital.bank-status-user_authorization_not_granted',
        tooltipKey: 'contabilidade-digital.bank-status-user_authorization_not_granted-tooltip',
        variant: 'error',
    },
    [ConsentStatusCode.USER_AUTHORIZATION_REVOKED]: {
        labelKey: 'contabilidade-digital.bank-status-user_authorization_revoked',
        tooltipKey: 'contabilidade-digital.bank-status-user_authorization_revoked-tooltip',
        variant: 'error',
    },
    [ConsentStatusCode.USER_NOT_SUPPORTED]: {
        labelKey: 'contabilidade-digital.bank-status-user_not_supported',
        tooltipKey: 'contabilidade-digital.bank-status-user_not_supported-tooltip',
        variant: 'error',
    },
    [ConsentStatusCode.ACCOUNT_CREDENTIALS_RESET]: {
        labelKey: 'contabilidade-digital.bank-status-account_credentials_reset',
        tooltipKey: 'contabilidade-digital.bank-status-account_credentials_reset-tooltip',
        variant: 'error',
    },
    [ConsentStatusCode.CONNECTION_ERROR]: {
        labelKey: 'contabilidade-digital.bank-status-connection_error',
        tooltipKey: 'contabilidade-digital.bank-status-connection_error-tooltip',
        variant: 'error',
    },
    [ConsentStatusCode.ACCOUNT_PENDING_ISSUES]: {
        labelKey: 'contabilidade-digital.bank-status-account_pending_issues',
        tooltipKey: 'contabilidade-digital.bank-status-account_pending_issues-tooltip',
        variant: 'error',
    },
    [ConsentStatusCode.CONNECTION_TIMEOUT]: {
        labelKey: 'contabilidade-digital.bank-status-connection_timeout',
        tooltipKey: 'contabilidade-digital.bank-status-connection_timeout-tooltip',
        variant: 'error',
    },
    [ConsentStatusCode.USER_AUTHORIZATION_PENDING]: {
        labelKey: 'contabilidade-digital.bank-status-user_authorization_pending',
        tooltipKey: 'contabilidade-digital.bank-status-user_authorization_pending-tooltip',
        variant: 'info',
    },
    [ConsentStatusCode.PENDING_MULTIPLE_SIGNATURES]: {
        labelKey: 'contabilidade-digital.bank-status-pending_multiple_signatures',
        tooltipKey: 'contabilidade-digital.bank-status-pending_multiple_signatures-tooltip',
        variant: 'info',
    },
    [ConsentStatusCode.CONNECTION_CLOSED]: {
        labelKey: 'contabilidade-digital.bank-status-connection_closed',
        tooltipKey: 'contabilidade-digital.bank-status-connection_closed-tooltip',
        variant: 'error',
    },
    [ConsentStatusCode.UNKNOWN]: {
        labelKey: 'contabilidade-digital.bank-status-unknown',
        tooltipKey: 'contabilidade-digital.bank-status-unknown-tooltip',
        variant: 'error',
    },
};
export const belvoRedoConnectionDisplay = {
    labelKey: 'contabilidade-digital.bank-status-belvo_redo_connection',
    tooltipKey: 'contabilidade-digital.bank-status-belvo_redo_connection-tooltip',
    variant: 'error',
};
export const resolveStatusDisplay = (code, syncStatus, partner) => {
    if (partner === ConsentPartner.BELVO) {
        return belvoRedoConnectionDisplay;
    }
    return statusDisplay[`${code}:${syncStatus}`] ?? statusDisplay[code] ?? statusDisplay[ConsentStatusCode.UNKNOWN];
};
